import SettingsPage from './SettingsPage';
import settingsPageReducer from './reducer';

export { settingsPageReducer };
export default SettingsPage;
